import {
  CorpInvoicingMethod,
  ReportingOption,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { InvoiceMethod, InvoicingSubtotalMethod } from 'src/types/Corp';

export type InvoicingMethodType = {
  invoicingMethod: InvoiceMethod;
  invoicingSubtotalMethod: InvoicingSubtotalMethod;
};

export function transformInvoicingMethodUItoModel(
  invoicingMethod: CorpInvoicingMethod,
  reporting: ReportingOption
): InvoicingMethodType {
  switch (reporting) {
    case ReportingOption.LOCATIONS_REPORTING_OPTION:
      return getLocationReportingSettings(invoicingMethod);
    case ReportingOption.DEPARTMENTS_REPORTING_OPTION:
      return getDepartmentReportingSettings(invoicingMethod);
    default:
      return getDefaultInvoicingMethodSettings();
  }
}

export function transformInvoicingMethodModelToUI(
  invoicingMethod: InvoiceMethod,
  invoicingSubtotalMethod: InvoicingSubtotalMethod
): CorpInvoicingMethod {
  if (
    invoicingMethod === InvoiceMethod.MULTI_LOCATION ||
    invoicingMethod === InvoiceMethod.MULTI_DEPARTMENT
  ) {
    return CorpInvoicingMethod.MULTI_OPTION;
  }

  if (invoicingMethod === InvoiceMethod.SINGLE) {
    if (
      invoicingSubtotalMethod ===
        InvoicingSubtotalMethod.LOCATION_SUBTOTAL_INVOICE_METHOD ||
      invoicingSubtotalMethod ===
        InvoicingSubtotalMethod.DEPARTMENT_SUBTOTAL_INVOICE_METHOD
    ) {
      return CorpInvoicingMethod.SUBTOTAL_OPTION;
    }

    if (
      invoicingSubtotalMethod ===
      InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD
    ) {
      return CorpInvoicingMethod.SINGLE_OPTION;
    }
  }

  return CorpInvoicingMethod.SINGLE_OPTION;
}

function getLocationReportingSettings(
  invoicingMethod: CorpInvoicingMethod
): InvoicingMethodType {
  switch (invoicingMethod) {
    case CorpInvoicingMethod.SINGLE_OPTION:
      return getLocationSingleMethodSettings();
    case CorpInvoicingMethod.SUBTOTAL_OPTION:
      return getLocationSubtotalMethodSettings();
    case CorpInvoicingMethod.MULTI_OPTION:
      return getLocationMultiMethodSettings();
    default:
      return getDefaultInvoicingMethodSettings();
  }
}

function getDepartmentReportingSettings(
  invoicingMethod: CorpInvoicingMethod
): InvoicingMethodType {
  switch (invoicingMethod) {
    case CorpInvoicingMethod.SINGLE_OPTION:
      return getDepartmentSingleMethodSettings();
    case CorpInvoicingMethod.SUBTOTAL_OPTION:
      return getDepartmentSubtotalMethodSettings();
    case CorpInvoicingMethod.MULTI_OPTION:
      return getDepartmentMultiMethodSettings();
    default:
      return getDefaultInvoicingMethodSettings();
  }
}

function getLocationSingleMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.SINGLE,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD,
  };
}

function getLocationSubtotalMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.SINGLE,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.LOCATION_SUBTOTAL_INVOICE_METHOD,
  };
}

function getLocationMultiMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.MULTI_LOCATION,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.LOCATION_SUBTOTAL_INVOICE_METHOD,
  };
}

function getDepartmentSingleMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.SINGLE,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD,
  };
}

function getDepartmentSubtotalMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.SINGLE,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.DEPARTMENT_SUBTOTAL_INVOICE_METHOD,
  };
}

function getDepartmentMultiMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.MULTI_DEPARTMENT,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.DEPARTMENT_SUBTOTAL_INVOICE_METHOD,
  };
}

function getDefaultInvoicingMethodSettings(): InvoicingMethodType {
  return {
    invoicingMethod: InvoiceMethod.SINGLE,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD,
  };
}
